import { Outlet, NavLink } from 'react-router-dom'
import Logo from '../assets/m2-logo.png'

function Nav() {
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 rounded-xl transition hover:bg-white/10 ${isActive ? 'bg-white/10' : ''}`

  return (
    <nav className="fixed inset-x-0 top-0 z-50">
      <div className="mx-auto max-w-7xl px-4 flex justify-center">
        <div className="mt-4 flex items-center justify-center rounded-2xl glass px-3 py-2 shadow-soft mx-auto w-fit">
          <div className="flex items-center gap-2 text-sm font-medium">
            <NavLink to="/" className={linkClass} end>Start</NavLink>
            <NavLink to="/projects" className={linkClass}>Projekte</NavLink>
            <NavLink to="/nft-hub" className={linkClass}>NFT-Hub</NavLink>
            <NavLink to="/about" className={linkClass}>Über uns</NavLink>
            <NavLink to="/contact" className={linkClass}>Kontakt</NavLink>
          </div>
        </div>
      </div>
    </nav>
  )
}

function Footer() {
  return (
    <footer className="mt-20 border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 py-10 text-sm text-slate-400">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} M2 Websolutions GbR</p>
          <div className="flex gap-4">
            <a className="hover:text-white" href="/about">Impressum</a>
            <a className="hover:text-white" href="/contact">Kontakt</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default function App() {
  return (
    <div>
      {/* Navbar */}
      <Nav />

      <a
        href="/"
        aria-label="Startseite – M2 Websolutions"
        className="fixed left-8 top-0 md:left-10 md:top-0 -translate-y-1 md:-translate-y-1 z-[60] block rounded-lg opacity-90 hover:opacity-100 transition"
      >

        <img
          src={Logo}
          alt="M2 Websolutions"
          className="h-12 md:h-44 w-44 logo-glow select-none pointer-events-auto"
        />
      </a>

      {/* Seiteninhalt */}
      <main className="pt-28">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}
